$(function() {
    $('a[data-toggle="tab"]').on('show.bs.tab', function (event) {
        event.target // newly activated tab
        event.relatedTarget // previous active tab
        $(event.target).removeClass('c-button--outline').addClass('c-button--active')
        $(event.relatedTarget).removeClass('c-button--active').addClass('c-button--outline')
    })
})